export const FeatureFlag = {
  CLAIMS_OVERVIEW: 'claims-overview',
}
